import { Component, Injector, OnInit, ViewEncapsulation } from '@angular/core';
import { ItemsListContainerBase } from '@fi-app/components/items-list-container-base';
import { CustomerBillingCustomerListData } from '../customer-billing-customer-list-data';
import { IFiHttpPromise } from '@fi-shared/to-fi-promise';
import { CustomerService } from '../customer.service';
import { CoreParameterModel, ILightWeightObjectCollection } from '@fi-shared/models';
import { ObjectTypes } from '@fi-shared/types/object-type';
import { CustomerBillingCustomerModel } from '../customer-billing-customer.model';
import { AppTextService } from '@fi-shared/app-text';
import { TabsModuleService } from '@fi-app/utilities/tabs/tabs-module.service';
import { FiLocalSearchGroupType } from '@fi-shared/fi-local-search2/fi-local-search-group-type';

@Component({
    selector: 'fi-customer-billing-customer-list',
    template: `<fi-items-list class="customer-billing-customer-list" [settings]="ListData"></fi-items-list>`,
    styleUrls: ['./customer-billing-customer-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class CustomerBillingCustomerListComponent
    extends ItemsListContainerBase<CustomerBillingCustomerListData>
    implements OnInit
{
    constructor(
        private customerService: CustomerService,
        private appTextService: AppTextService,
        private injector: Injector,
        private tabsModuleService: TabsModuleService,
    ) {
        super();
    }

    ngOnInit() {
        super.onInit(() => new CustomerBillingCustomerListData(this.injector), {
            showDelete: false,
        });

        this.tabsModuleService.setTabsSettings({
            listData: this.ListData,
        });
    }

    protected LoadItems(): Promise<void> {
        return this.customerService.GetCustomers(this.getLoadParameter()).then((response) => {
            //const data = response.map(item => new CustomerBillingCustomerModel(item, this.injector));
            this.ListData.appendData(response);
        });
    }

    protected SetItemsCount(): IFiHttpPromise<number> {
        return this.customerService.GetCustomersCount(this.getLoadParameter());
    }

    InitializeLocalSearchData() {
        return this.customerService.GetObjectsForCustomersLocalSearch().then((lightWeightObjectCollection) => {
            this.ListData.raiseLightWeightObjectCollectionChanged(lightWeightObjectCollection);
        });
    }

    private getLoadParameter() {
        const parameterModel = new CoreParameterModel();
        Object.assign(parameterModel, this.ListData.getFilterParams());

        Object.assign(parameterModel, this.ListData.getOffsetParams());

        parameterModel.SelectedSort = {
            ColumnName: this.ListData.Sort.Column,
            SortDirection: this.ListData.Sort.Reverse,
        };

        this.ListData.mergeLocalSearchV2Parameter(parameterModel);

        return parameterModel;
    }
}
